module.exports = __webpack_public_path__ + "static/media/gjunior_smart_saving_icon.417555a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/gjunior_smart_saving_icon.svg
// module id = 325
// module chunks = 21